import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-cancel-footer',
  templateUrl: './confirm-cancel-footer.component.html',
  styleUrls: ['./confirm-cancel-footer.component.sass']
})
export class ConfirmCancelFooterComponent {
  @Input() promise: Promise<any>;
  @Input() cancelDisabled = false;
  @Input() confirmDisabled = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
}
